"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSellYourElectricity = function IconSellYourElectricity(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M7.045 13.46a40.7 40.7 0 0 0 9.086 1.965 7.88 7.88 0 0 0 15.745-.186q1.081-.329 2.095-.83l.339.811L36 13l-2.77-.36.353.844-.059.03q-.817.406-1.684.688a7.881 7.881 0 0 0-15.7.22 39.7 39.7 0 0 1-10.788-2.654l-1.226-1.226q-.577.85-1.08 1.748l18.112 18.113-.13 4.597H15v10h2v-8h5.972l.21-7.402zM29.88 15a5.88 5.88 0 1 0-11.76 0 5.88 5.88 0 0 0 11.76 0M43 38.665q-.93 1.201-2 2.276V18h-6v-2h6v-6h-6V8h6.889q.579.647 1.11 1.335V16h3.635q.06.167.116.335V18H43zM9 28v11H7v-9H2v-2zm13.28-12.39 2.3-4.61v3.39h1.15L23.43 19v-3.39z",
    clipRule: "evenodd"
  })));
};

export { IconSellYourElectricity, IconSellYourElectricity as default };
